"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabels = void 0;
const createTranslationObject = (obj) => obj;
const labels = {
    ADMIN_PAGES: createTranslationObject({ enUs: "Administrative pages", nbNO: "Administrative sider" }),
    CUSTOMERS_RESPONSIBLE: createTranslationObject({ enUs: "Customer responsible", nbNO: "Kundeansvarlige" }),
    ALARM_ATTACKCATEGORIES: createTranslationObject({ enUs: "Attackcategories", nbNO: "Attackcategories" }),
    ALARM_BROWSER: createTranslationObject({ enUs: "Alarm browser", nbNO: "Alarmgrensesnitt" }),
    ALARM_MAPPING: createTranslationObject({ enUs: "Alarm mapping", nbNO: "Alarm mapping" }),
    ALARM_SEARCH: createTranslationObject({ enUs: "Alarm search", nbNO: "Alarm søk" }),
    ANALYSIS_FILTER: createTranslationObject({ enUs: "Analysis filter", nbNO: "Analysefilter" }),
    ANNOTATION_FILTER: createTranslationObject({ enUs: "Annotation filter", nbNO: "Annotasjonsfilter" }),
    API_DOC: createTranslationObject({ enUs: "API Documentation", nbNO: "API-Dokumentasjon" }),
    API: createTranslationObject({ enUs: "API", nbNO: "API" }),
    APU_DOCUMENTATION: createTranslationObject({ enUs: "API Documentation", nbNO: "API-Dokumentasjon" }),
    ASSETS_SEARCH: createTranslationObject({ enUs: "Assets search", nbNO: "Assets søk" }),
    ASSETS: createTranslationObject({ enUs: "Assets", nbNO: "Assets" }),
    CASE_CREATE_BETA: createTranslationObject({ enUs: "Create case", nbNO: "Opprett sak" }),
    CASE_SEARCH: createTranslationObject({ enUs: "Case search", nbNO: "Sakssøk" }),
    CASE: createTranslationObject({ enUs: "Case", nbNO: "Saker" }),
    CHAT: createTranslationObject({ enUs: "Chat", nbNO: "Chat" }),
    COMPONENTS_HOSTS: createTranslationObject({ enUs: "Components hosts", nbNO: "Konfigurasjon - systemer" }),
    COMPONENTS_MONITOR: createTranslationObject({ enUs: "Components monitor", nbNO: "Komponentmonitor" }),
    COMPONENTS_TEMPLATES: createTranslationObject({ enUs: "Components templates", nbNO: "Konfigurasjon - maler" }),
    COMPONENTS: createTranslationObject({ enUs: "Components", nbNO: "Komponenter" }),
    CUSTOMER_PAGES: createTranslationObject({ enUs: "Customer pages", nbNO: "Kundesider" }),
    CUSTOMERS_DOMAIN: createTranslationObject({ enUs: "Customer domain", nbNO: "Kundedomene" }),
    CUSTOMERS_NETWORK: createTranslationObject({ enUs: "Customers networks", nbNO: "Kundenettverk" }),
    CUSTOMERS_USER_ROLES: createTranslationObject({ enUs: "User roles", nbNO: "Brukerroller" }),
    CUSTOMERS: createTranslationObject({ enUs: "Customers", nbNO: "Kunder" }),
    DASHBOARD: createTranslationObject({ enUs: "Dashboard", nbNO: "Dashbord" }),
    DATA_INSIGHT: createTranslationObject({ enUs: "Data and insight", nbNO: "Data og innsikt" }),
    DATASTORE: createTranslationObject({ enUs: "Datastore", nbNO: "Datastore" }),
    DOCUMENTS: createTranslationObject({ enUs: "Documents", nbNO: "Dokumenter" }),
    EVENT_FILTER: createTranslationObject({ enUs: "Event filter", nbNO: "Hendelse filter" }),
    EVENT_MANAGEMENT: createTranslationObject({ enUs: "Event management", nbNO: "Hendelseadministrasjon" }),
    EVENT_SEARCH: createTranslationObject({ enUs: "Event search", nbNO: "Hendelsessøk" }),
    EXT_APPS: createTranslationObject({ enUs: "External apps", nbNO: "Eksterne applikasjoner" }),
    FUNCTIONS: createTranslationObject({ enUs: "Functions", nbNO: "Funksjoner" }),
    GROUPS: createTranslationObject({ enUs: "Groups", nbNO: "Grupper" }),
    KNOWLEDGE_BASE: createTranslationObject({ enUs: "Knowledge base", nbNO: "Kunnskapsbase" }),
    LOCATIONS: createTranslationObject({ enUs: "Locations", nbNO: "Lokasjoner" }),
    LOGO_ALT_MNE: createTranslationObject({ enUs: "argus logo", nbNO: "argus logo" }),
    LOGO_ALT_NFC: createTranslationObject({ enUs: "nfcert logo", nbNO: "nfcert logo" }),
    LOGOUT: createTranslationObject({ enUs: "Logout", nbNO: "Logg ut" }),
    MATCH_FILTER: createTranslationObject({ enUs: "Match filter", nbNO: "Matchfilter" }),
    NFCERT_SERVICES: createTranslationObject({ enUs: "NFCert Services", nbNO: "NFCert Tjenester" }),
    OBSERVATIONS: createTranslationObject({ enUs: "Observations", nbNO: "Observasjoner" }),
    OVERRIDE_LIST: createTranslationObject({ enUs: "Override list", nbNO: "Overstyringsliste" }),
    OVERRIDES: createTranslationObject({ enUs: "Overrides", nbNO: "Overstyringer" }),
    PDNS_BETA: createTranslationObject({ enUs: "Passive DNS", nbNO: "Passive DNS" }),
    PERMISSIONS: createTranslationObject({ enUs: "Permissions", nbNO: "Tillatelser" }),
    REALTIME: createTranslationObject({ enUs: "Realtime", nbNO: "Sanntid" }),
    REPORTS: createTranslationObject({ enUs: "Reports", nbNO: "Rapporter" }),
    REPUTATION_SEARCH: createTranslationObject({ enUs: "Reputation search", nbNO: "Reputation søk" }),
    REPUTATION: createTranslationObject({ enUs: "Reputation", nbNO: "Reputation" }),
    ROLES: createTranslationObject({ enUs: "Roles", nbNO: "Roller" }),
    ROOT_FOLDER: createTranslationObject({ enUs: "Root folder", nbNO: "Rotmappen" }),
    SAMPLE_DB: createTranslationObject({ enUs: "Sample database", nbNO: "Sample-database" }),
    SEARCH: createTranslationObject({ enUs: "Search", nbNO: "Søk" }),
    SENSOR_LIST: createTranslationObject({ enUs: "Sensor list", nbNO: "Sensorliste" }),
    SENSOR_STATUS: createTranslationObject({ enUs: "Sensor status", nbNO: "Sensorstatus" }),
    SENSOR: createTranslationObject({ enUs: "Sensor", nbNO: "Sensor" }),
    SERVICE_HANDBOOK: createTranslationObject({ enUs: "Service Handbook", nbNO: "Tjenestehåndbok" }),
    SERVICE_PAGES: createTranslationObject({ enUs: "Service pages", nbNO: "Tjenestesider" }),
    SOURCES: createTranslationObject({ enUs: "Sources", nbNO: "Kilder" }),
    SWAGGER: createTranslationObject({ enUs: "Swagger", nbNO: "Swagger" }),
    TI: createTranslationObject({ enUs: "Threat intelligence", nbNO: "Threat intelligence" }),
    USER_MANAGEMENT: createTranslationObject({ enUs: "User management", nbNO: "Brukeradministrasjon" }),
    USER_PREFS: createTranslationObject({ enUs: "User preferences", nbNO: "Brukerprofil" }),
    USERS: createTranslationObject({ enUs: "Users", nbNO: "Brukere" }),
    WIKI: createTranslationObject({ enUs: "Wiki", nbNO: "Wiki" }),
};
const nbNO = Object.keys(labels).reduce((obj, key) => ({ ...obj, [key]: labels[key]["nbNO"] }), {});
const enUs = Object.keys(labels).reduce((obj, key) => ({ ...obj, [key]: labels[key]["enUs"] }), {});
const getLabels = (locale) => {
    switch (locale) {
        case "nb-NO":
            return nbNO;
        case "en-US":
        default:
            return enUs;
    }
};
exports.getLabels = getLabels;
